module.exports = __webpack_public_path__ + "img/question_B0.90b24ebb.svg";